import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LogoWatermarks from "./LogoWatermarks";

export const PublicLayout = () => (
    <div className="min-h-screen bg-white">
        <Navbar />
        <LogoWatermarks />
        <main>
            <Outlet />
        </main>
        <Footer />
    </div>
);

export default PublicLayout;
